
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getListData" placeholder="赛事名称"></el-input>
				</el-form-item>
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">	
    </el-table-column>  
	
			<!-- <el-table-column prop="CompetitionTypeName" label="赛事分类" width="120" sortable>
			</el-table-column>             -->
			<el-table-column prop="Name" label="赛事名称" width="240" sortable>
			</el-table-column>
  			  <el-table-column prop="CompetitionState" label="赛事状态" width="120" >				  
				<template slot-scope="scope">			
                      <el-tag type="info"  v-if="scope.row.CompetitionState==0" size="small" >新增</el-tag>
                      <el-tag type="warning"  v-else-if="scope.row.CompetitionState==1" size="small" >准备</el-tag>
					   <el-tag type="primary"   v-else-if="scope.row.CompetitionState==2" size="small" >发布</el-tag>
					  <el-tag type="success"   v-else-if="scope.row.CompetitionState==3" size="small" >报名</el-tag>
					  <el-tag type="success"   v-else-if="scope.row.CompetitionState==4" size="small" >报名结束</el-tag>
					  <el-tag type="danger"   v-else-if="scope.row.CompetitionState==5" size="small" >比赛</el-tag>
					  <el-tag type="danger"   v-else-if="scope.row.CompetitionState==6" size="small" >比赛结束</el-tag>
					  <el-tag type="blue"   v-else-if="scope.row.CompetitionState==7" size="small" >赛事完结</el-tag>
				</template>
			</el-table-column>                      
 			<el-table-column prop="GroupCount" label="组数" width="100" sortable>
			</el-table-column>	
 			<el-table-column prop="Number" label="队伍可报人数" width="145" sortable>
			</el-table-column>					
 			<el-table-column prop="ContactName" label="联系人" width="100" sortable>
			</el-table-column>	
 			<el-table-column prop="ContactNumber" label="号码" width="125" sortable>
			</el-table-column>								  
			<el-table-column prop="RegistrationStart" label="报名开始时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>
			<el-table-column prop="RegistrationEnd" label="报名结束时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>
			<!-- <el-table-column prop="IDnumber" label="报名剩余时间" width="150"  sortable>
			</el-table-column> -->
			<el-table-column prop="StartTime" label="比赛开始时间" width="150" :formatter="formatDate"   sortable>
			</el-table-column>
 			<el-table-column prop="EndTime" label="比赛结束时间" width="150" :formatter="formatDate"  sortable>
			</el-table-column>   
  			<el-table-column prop="Addres" label="举办地点" width="240"  sortable>
			</el-table-column>                    
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" min-width="220" fixed="right">
				<template  slot-scope="scope">
                     <el-button type="warning" size="small" @click="ShowEntry(scope.row)">进入报名</el-button>		
					 <el-button type="primary" size="small" @click="achievementmanage(scope.row)">赛事成绩</el-button>								
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个赛事</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<el-dialog title="赛事成绩列表" v-model="achievementmanageVisivle" :close-on-click-modal="false">
           <el-table :data="achienementList" highlight-current-row >
			   <el-table-column  prop="FileName" label="文件名" min-width="180"  >                  
				</el-table-column>	
			   <el-table-column  prop="CreationTime" label="添加时间" min-width="180"  >                  
				</el-table-column>																					
			<el-table-column label="操作" width="150" fixed="right">
				<template  slot-scope="scope">					
					<el-button type="primary" size="small" @click="FileDown(scope.row)">下载成绩单</el-button>
				</template>
			</el-table-column>							
		   </el-table>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapState, mapMutations,mapGetters, mapActions} from 'vuex';

	//import NProgress from 'nprogress'
	import {DownFile,CompetitionFileList,CompetitionEntryList } from '../../api/api';

	export default {
		data() {
			return {
				achienementList:[],
				CompetitionId:0,
                achievementmanageVisivle:false,
				filters: {
					Name: '',
					Type:'',				
				},
				fit:'contain',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
			}
		},
		methods: {
			FileDown(row){
				let para={
					id:row.Id,
				}
				// console.log(para);
				DownFile(para).then((res)=>{
					 let {status}=res;	
					//  console.log(status);
					 if(status==200)
					 {
	   let blob = new Blob([res.data], {type: "application/pdf"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = row.FileName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
					 }					
				}).catch(error=>{					
                 alert('网络错误');
                });                
			},			
		FileList(value)
			{
				let para={
					CompetitionId:value,
				}
				// console.log(para);
				CompetitionFileList(para).then((res)=>{
					// console.log(res);
                  this.achienementList=res.data.Data;
				}).catch(error=>{					
                 alert('网络错误');
                });
			},			
		 achievementmanage(row){
				this.achievementmanageVisivle=true;
				this.CompetitionId=row.Id;
				this.FileList(row.Id);
			},			
          ...mapGetters(['getshopInfo']),	
         ...mapMutations(['Setcompetition']),
		 ShowEntry(row)
	      {
			//   console.log("111"+JSON.stringify(row));
			  var CompetitionState=this.getshopInfo().CompetitionState;
			  if(CompetitionState!=1)
			  {
			  this.Setcompetition(JSON.stringify(row));			 			  
		   var _this = this;
		    this.$router.push({
          name: '报名视图',
		   })
			  }else
			  {
                   this.$message({
				    message: '您的门店没有赛事报名权限,请联系总部开通',
					type: 'error'
			     	});				  
			  }

		   },
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : row.Sex == 2?'混合':'未知';
			},
			formatType: function (row, column) {
  				return row.Type == 0 ? '普通组' : row.Type == 1 ? '接力组' : '未知';
                 
			},

			formatDate: function (row, column) {
				if(column.property=='RegistrationStart')
				{
				return util.formatDate.format(new Date(row.RegistrationStart), 'yyyy-MM-dd');

				}
				if(column.property=='RegistrationEnd')
				{
				return util.formatDate.format(new Date(row.RegistrationEnd), 'yyyy-MM-dd');

				}
				if(column.property=='StartTime')
				{
				return util.formatDate.format(new Date(row.StartTime), 'yyyy-MM-dd');

				}		
				if(column.property=='EndTime')
				{
				return util.formatDate.format(new Date(row.EndTime), 'yyyy-MM-dd');

				}							
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},

			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Type:this.filters.Type,
				};
				this.listLoading = true;
				//NProgress.start();
				CompetitionEntryList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},				
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getListData();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit; 
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// CompetitionEntry.vue?1076ab50